import React from "react"
import Guide from "../base-pages/guide"

const GuideCN = () => {
  return <Guide lang="cn" />
}

export default GuideCN
